import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import compose from 'recompose/compose';
import { withTranslation } from 'react-i18next';

import { router } from 'app/selectors/router';
import withToggle from 'app/common/containers/withToggle';
import get from 'app/common/lib/get';


export default compose(
  withRouter,

  withTranslation('subs'),

  connect(
    (state, props) => {
      const studentId = parseInt(router.getParam('id', props), 10);
      const subId = get(state, ['apps', 'data', props.service, studentId], null);
      return ({
        studentId,
        subId,
      });
    }
  ),

  withToggle()
);
